$(document).ready(function() {
  var naturalForm = $('#natural-user-inputs');
  var legalForm = $('#legal-user-inputs');

  if ($('[id$=_type]').val() === 'User::Legal') {
    showForm(naturalForm);
    showForm(legalForm);
  } else {
    showForm(legalForm);
    showForm(naturalForm);
  }


  $('input[type=radio][name="user[type]"]').change(function() {
    if (this.value === 'User::Natural') {
      $('[id$=_type]').val('User::Natural');
      showForm(naturalForm);
    } else {
      $('[id$=_type]').val('User::Legal');
      showForm(legalForm);
    }
  });

  function showForm(form) {
    $('#partial-anchor').html(form);
    $('#partial-anchor > div').removeClass('hidden');
    $('[data-toggle="tooltip"]').tooltip();
  }
});
